import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import { Helmet } from "react-helmet-async";

const serviceItems = [
    {
        id: 1,
        title: "Break down silos by unifying security, risk, and compliance",
        description: "Connect disparate security, risk, and governance workflows into a unified operational model to ensure consistent oversight across the enterprise.",
        image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Gain real-time risk insights to prioritize critical threats",
        description: "Leverage continuous risk telemetry and predictive analytics to identify, evaluate, and mitigate mission-critical business vulnerabilities before impact.",
        image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Centralize security and compliance controls to eliminate gaps",
        description: "Standardize policy enforcement, evidence collection, and automated controls across multi-cloud and on-premise ecosystems to prevent compliance drift.",
        image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 4,
        title: "Align governance with regulatory and business priorities",
        description: "Bridge executive strategy with technical risk management, ensuring regulatory audit readiness while accelerating strategic business initiatives.",
        image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 5,
        title: "Equip leadership with clear, decision-ready risk intelligence",
        description: "Deliver intuitive executive dashboards and transparent risk exposure metrics to empower informed, high-impact business decisions.",
        image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1000&q=80"
    }
];
const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Innovation and AI",
        desc: "Accelerate innovation with AI-driven platforms, scalable digital foundations, and new workflows that unlock growth and future-ready transformation.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "Governance, Risk & Compliance",
        desc: "We help organizations build strong governance and risk foundations with connected compliance, business continuity, and third-party risk programs. Stay audit-ready, reduce exposure, and manage risk proactively across the enterprise.",
        products: ["IRM", "BCM", "TPRM"]
    },
    {
        id: 2,
        title: "Security Operations & Cyber Resilience",
        desc: "We help enterprises strengthen security operations with faster incident response, continuous vulnerability management, and automated threat remediation. Detect issues early, respond to smarter, and improve cyber resilience at scale.",
        products: ["SecOps", "SIR", "VR"]
    },
    {
        id: 3,
        title: "Workplace Security",
        desc: "We help organizations secure the employee environment with controlled software usage, asset compliance, and endpoint governance. Reduce workplace risk while enabling productivity across teams",
        products: ["SAM"]
    }
];


const industryTabs = [
    {
        id: "manufacturing",
        label: "Manufacturing",
        title: "Manufacturing",
        desc: "We help manufacturers secure operational technology, strengthen third-party risk oversight, and embed compliance across plants, supply networks, and digital production environments.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "bfsi",
        label: "BFSI",
        title: "BFSI",
        desc: "Enabling financial institutions to manage regulatory risk, strengthen cybersecurity controls, and enhance governance frameworks in highly regulated, high-trust environments.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "retail",
        label: "Retail",
        title: "Retail",
        desc: "From protecting customer data to managing vendor and payment risk, we help retailers reduce exposure while maintaining secure, frictionless operations across channels.",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "telecom",
        label: "Telecommunication",
        title: "Telecommunication",
        desc: "We support telecom providers in safeguarding critical infrastructure, managing large-scale cyber risk, and ensuring regulatory compliance across distributed networks and ecosystems.",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "Dedicated Tribes",
        desc: "Our dedicated experts apply deep knowledge and hands-on capability to deliver precise solutions and faster results."
    },
    {
        id: 2,
        title: "Continuous Improvement",
        desc: "We continuously refine controls and processes to strengthen resilience and keep pace with evolving risks and regulations."
    },
    {
        id: 3,
        title: "Cross-Platform Capabilities",
        desc: "We integrate risk, security, and compliance workflows across systems for unified visibility and coordinated enterprise-wide control."
    },
    {
        id: 4,
        title: "AI-Driven Approach",
        desc: "We use AI and automation to detect risks faster, improve response speed, and enhance decision-making across the enterprise."
    }
];


const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];
const faqData = [
    {
        id: 1,
        question: "What is Enterprise Security Risk Management (ESRM)",
        answer: "Enterprise Security Risk Management (ESRM) is a strategic approach that ties security practices directly to overall business goals, treating security as an enterprise-wide risk management discipline rather than an isolated IT function."
    },
    {
        id: 2,
        question: "How can it help organizations address risks, threats, and vulnerabilities?",
        answer: "It creates a unified view across digital and operational environments, enabling continuous threat prioritization, automated control testing, and rapid remediation to prevent disruptions before they impact business value."
    },
    {
        id: 3,
        question: "How does Mobikode help establish global security departments?",
        answer: "We design resilient operating models, standardize cross-regional governance frameworks, and implement integrated ServiceNow SecOps and IRM workflows tailored to global regulatory requirements."
    },
    {
        id: 4,
        question: "Why choose Mobikode for cybersecurity services?",
        answer: "We bring end-to-end platform mastery across ServiceNow, combining strategic risk advisory, automated incident orchestration, and proactive compliance to build long-term cyber resilience."
    }
];


function ResilientSecurity() {
    return (
        <div>
                      <Helmet>

                {/* Primary SEO */}
                <title>
                    Risk & Security Solutions | ServiceNow SecOps & IRM | Mobikode
                </title>

                <meta
                    name="description"
                    content="Strengthen enterprise security, risk, and compliance with Mobikode's ServiceNow solutions. Improve governance, cybersecurity, risk management, compliance, SecOps, IRM, vulnerability management, and cyber resilience."
                />

                <meta
                    name="keywords"
                    content="Risk and Security Solutions, ServiceNow Security Operations, ServiceNow SecOps, ServiceNow IRM, ServiceNow GRC, ServiceNow Risk Management, ServiceNow Vulnerability Response, ServiceNow Security Incident Response, Enterprise Risk Management, Governance Risk and Compliance, GRC Solutions, Cybersecurity Solutions, Cyber Resilience, Risk Management Consulting, Compliance Management, Third Party Risk Management, Business Continuity Management, ServiceNow Security Consulting"
                />

                {/* Search Engine Indexing */}
                <meta
                    name="robots"
                    content="index, follow, max-image-preview:large"
                />

                <meta
                    name="googlebot"
                    content="index, follow"
                />

                {/* Canonical */}
                <link
                    rel="canonical"
                    href="https://www.mobikode.com/risk-security"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Risk & Security Solutions | ServiceNow SecOps & IRM | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Protect enterprise value with connected risk, security, governance, and compliance solutions powered by ServiceNow SecOps and IRM."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/risk-security"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Mobikode"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/glodesk/bg2.png"
                />

                <meta
                    property="og:image:alt"
                    content="Mobikode Risk and Security Solutions"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Risk & Security Solutions | ServiceNow SecOps & IRM | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Enterprise risk, cybersecurity, compliance, SecOps, IRM, and cyber resilience solutions from Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/glodesk/bg2.png"
                />

                {/* Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Risk & Security Solutions",
                        "serviceType": "Enterprise Risk and Security Management",
                        "description":
                            "Mobikode provides enterprise risk, security, governance, compliance, cybersecurity, and cyber resilience solutions using ServiceNow SecOps, IRM, vulnerability management, business continuity, and third-party risk management.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Mobikode",
                            "url": "https://www.mobikode.com/"
                        },
                        "areaServed": {
                            "@type": "Place",
                            "name": "Worldwide"
                        },
                        "url":
                            "https://www.mobikode.com/risk-security"
                    })}
                </script>

            </Helmet>
            <WhoHero
                title="For Resilient Security "
                text="Strengthen enterprise security management with unified oversight and intelligence-driven resilience that protects enterprise value and enables confident growth."
                imgData="/assets/glodesk/bg2.png"
            />
            <UserFirstExperienceSection title="Shield Your Enterprise with Risk & Security Solutions" description="Enterprise security management continues to challenge even organizations with established controls in place. As threats grow more sophisticated and regulatory demands intensify, what feels secure today can quickly fall short without unified visibility and proactive oversight. To address this complexity, we deliver an integrated approach to enterprise risk and security management, embedding intelligence, automation, and governance into the core of your operations to protect critical assets, strengthen resilience, and enable confident, growth-driven decisions." />
            <ServiceX360ViewSection title="Protect in evolving digital ecosystem with Risk and Security" description="Rethink how security, risk, and compliance work across your enterprise. Replace fragmented oversight with a connected approach that gives you clearer visibility, faster response, and stronger resilience where it matters most. With our enterprise risk and security management solutions, you can" serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our Full-Suite of Risk & Security Offerings" description="With our comprehensive risk and security solutions, Mobikode helps enterprises remain secure, safeguarded, and resilient against threats." />
            <IndustriesServiceExperienceSection title="Transforming Service Experiences Across Industries" industryTabs={industryTabs} />
            <WhatSetsApartSection title="Mobikode for Risk & Security" description="Our deep expertise across governance, risk, compliance, and cybersecurity transformation enables organizations to strengthen protection, accelerate maturity, and deliver measurable resilience outcomes across the enterprise." apartData={apartData} />
            <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} />
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default ResilientSecurity
